import { use } from 'i18next';
import React from 'react';
import ReactDOM from 'react-dom';
import { initReactI18next } from 'react-i18next';
import 'index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { en } from 'translations/en';
import { fi } from 'translations/fi';
import { sv } from 'translations/sv';
import App from 'ui/App';
import { AuthProvider } from 'utils/auth/auth-context';
import { createFrontendConfig, createUiContext, UiContextProvider } from 'utils/react/ui-context';
import { parseLangFromLocation } from 'utils/react/url-state-utils';

const language = parseLangFromLocation(window.location);

use(initReactI18next).init({ resources: { fi, en, sv }, lng: language });

document.documentElement.lang = language; // change document's primary language for screen readers

const uiContext = createUiContext({ config: createFrontendConfig() });

ReactDOM.render(
  <React.StrictMode>
    <UiContextProvider uiContext={uiContext}>
      <AuthProvider>
        <Router>
          <App />
        </Router>
      </AuthProvider>
    </UiContextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
